import { useEffect, useRef, useState } from "react";
import DocumentLibrary from "./DocumentLibrary";
import { buttonClass } from "./DocumentUI";

export default function LeadDocumentsPanel({ workspaceId, leadId, leadName }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const currentWorkspaceId = workspaceId || localStorage.getItem("autoappy_current_workspace_id");
  useEffect(() => {
    if (visible || !window.IntersectionObserver) return undefined;
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { rootMargin: "200px" });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visible]);
  return <div id="lead-documents" ref={ref}>
    {visible ? <DocumentLibrary workspaceId={currentWorkspaceId} leadId={leadId} leadName={leadName} compact /> : <section className="rounded-2xl border border-[#d6e5eb] bg-white p-5"><h3 className="font-semibold text-[#17384e]">Documents</h3><p className="mb-3 mt-1 text-sm text-[#6c8494]">Recordings and documents linked to this lead.</p><button type="button" onClick={() => setVisible(true)} className={buttonClass}>View documents</button></section>}
  </div>;
}
